import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-white text-zinc-900">
      <header className="border-b border-zinc-200 px-6 py-4 sticky top-0 bg-white/95 backdrop-blur z-10">
        <div className="max-w-3xl mx-auto flex items-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-zinc-600 hover:text-zinc-900"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" />
            Ana Sayfa
          </Link>
          <h1 className="text-lg font-bold tracking-tight">{title}</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <article className="prose prose-zinc max-w-none prose-headings:tracking-tight prose-headings:font-bold prose-h2:text-2xl prose-h2:mt-8 prose-h3:text-lg prose-p:text-zinc-700 prose-p:leading-relaxed prose-li:text-zinc-700">
          {children}
        </article>
      </main>
      <footer className="border-t border-zinc-200 mt-16 py-8 text-center text-xs text-zinc-500">
        Kolay Arşivim © {new Date().getFullYear()}
      </footer>
    </div>
  );
}
